import React, { useContext } from 'react'
import { UserContext } from 'shared/users/contexts/UserContext'
import { User } from 'routes/Customer/services/user.service'
import DeclarationTransitPartiesTab from 'features/declaration/form/components/transit-parties/TransitPartiesTab'
import DeclarationTab from 'features/declaration/form/components/DeclarationTab'
import DeclarationGeneralTab from 'features/declaration/form/components/general/index'
import DeclarationSummaryTab from 'features/declaration/form/components/summary/index'
import EventLog from 'features/declaration/event-log/components/EventLog'
import TransitHouseConsignmentsTab from '../house-consignment/components/TransitHouseConsignmentsTab'
import { Tab } from '../../components/editorTabs'
import DirectoTab, { DirectoTabHandle } from '../../components/DirectoTab'
import { UseTransitOperationFormReturn } from '../../../transit-operation/components/useTransitOperationForm'
import TransitOperationFormTabs from '../../../transit-operation/components/TransitOperationFormTabs'
import { useDeclarationEditorContext } from '../../contexts/DeclarationEditorContext'

export interface DeclarationEditorProps {
  form: UseTransitOperationFormReturn
  activeTab: Tab
  directoTabRef: React.RefObject<DirectoTabHandle>
  interactionsLocked: boolean
}

function TransitDeclarationTabs({
  form,
  activeTab,
  directoTabRef,
  interactionsLocked,
}: Readonly<DeclarationEditorProps>) {
  const { user }: { user: User | undefined } = useContext(UserContext)

  const { declarationData, editorData } = useDeclarationEditorContext()
  const { transitOperation, consignment } = declarationData

  return (
    <>
      <TransitOperationFormTabs
        activeTab={activeTab}
        form={form}
        generalTab={<DeclarationGeneralTab />}
        transitPartisTab={<DeclarationTransitPartiesTab />}
      />
      {consignment?.id && (
        <DeclarationTab tab="house-consignments" currentTab={activeTab}>
          <TransitHouseConsignmentsTab
            consignmentId={consignment.id}
            interactionsLocked={interactionsLocked}
          />
        </DeclarationTab>
      )}
      <DeclarationTab tab="summary" currentTab={activeTab}>
        <DeclarationSummaryTab consignmentId={consignment?.id ?? null} />
      </DeclarationTab>
      {user?.role === 'ADMIN' && transitOperation?.id ? (
        <DeclarationTab tab="directo" currentTab={activeTab}>
          <DirectoTab
            transitOperationId={transitOperation.id}
            directoEventId={transitOperation.directoId}
            ref={directoTabRef}
          />
        </DeclarationTab>
      ) : null}
      <DeclarationTab tab="logs" currentTab={activeTab}>
        <EventLog transitOperationId={transitOperation?.id ?? null} country={editorData?.country} />
      </DeclarationTab>
    </>
  )
}

export default TransitDeclarationTabs
